$(document).foundation();

jQuery(document).ready(function($) {
	var header = document.querySelector("header");
	var headroom  = new Headroom(header);
	
	headroom.init();
	mainHandler.init();
	menuNavHandler.init();
	layoutHandler.init();
	searchHandler.init();
	sendEmailHandler.init();
	blockVideoHandler.init();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		$(this).parent().addClass('responsive-embed widescreen')
	})

	// debugger
	$(window).on('resize', function() {
		$('.debugger .column-width').html($('.debugger .cell').eq(0).width())
		$('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
		$('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
	}).trigger('resize')


})

jQuery(document).on('gform_confirmation_loaded', function(event, formId){
	// hide intro paragraph on submit success
	if (formId == 1) {
		jQuery('.endorse-form-intro').hide();
	}
});
